import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {
    ExceptionListEntityRequest,
    ExceptionListEntityResponse,
    FormSearchExceptionListModel
} from "../types/exceptionList";
import {buildQueryParams} from "../../utils";
import {RatePlanResponse} from "../types/rateProductCodeLocationGroup";

export const useExceptionListRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/exception-list";

    function getExceptionList(exceptionListId: number): Promise<ExceptionListEntityResponse> {
        return GET(`${PATH}?id=${exceptionListId}`);
    }

    function isExceptionListInUse(exceptionListId: number): Promise<boolean> {
        return GET(`${PATH}/in-use?exceptionListId=${exceptionListId}`);
    }

    function getExceptionLists(): Promise<ExceptionListEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getExceptionListsByCommercialCategoryId(commercialCategoryId: string, dealers: string | string[], legalEntities: string | string[]): Promise<ExceptionListEntityResponse[]> {
        return GET(`${PATH}/get-by-category?commercialCategoryId=${commercialCategoryId}&dealers=${dealers}&legalEntities=${legalEntities}`);
    }

    function putExceptionList(exceptionList: ExceptionListEntityResponse): Promise<ExceptionListEntityResponse> {
        return PUT(`${PATH}`, exceptionList);
    }

    function postExceptionList(exceptionList: ExceptionListEntityRequest): Promise<ExceptionListEntityResponse> {
        return POST(`${PATH}`, exceptionList);
    }

    function deleteExceptionList(exceptionListId: number): Promise<number> {
        return DELETE(`${PATH}?id=${exceptionListId}`);
    }

    function terminateExceptionList(exceptionListId: number): Promise<ExceptionListEntityResponse> {
        return GET(`${PATH}/terminate?id=${exceptionListId}`);
    }

    function getExceptionListsPaged(filters: FormSearchExceptionListModel): Promise<PagedResponse<ExceptionListEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getRatePlan({
                             productCode,
                             locationGroupId,
                             showOnlyActive
                         }: { productCode: string, locationGroupId: number, showOnlyActive?: boolean }): Promise<RatePlanResponse[]> {
        return GET(`${PATH}/get-valid-rates?productCode=${productCode}&locationGroupId=${locationGroupId}&showOnlyActive=${showOnlyActive}`);
    }

    function getRatePlanPaged(filters: any): Promise<PagedResponse<RatePlanResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter/get-valid-rates${queryParams ? query + queryParams : ""}`);
    }

    function getExceptionPagedProductPlan(filters: any): Promise<PagedResponse<ExceptionListEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter/get-valid-exception-list${queryParams ? query + queryParams : ""}`);
    }

    function getExceptionListPlan({
                                      productCode,
                                      locationGroup
                                  }: { productCode: string, locationGroup: number }): Promise<ExceptionListEntityResponse[]> {
        return GET(`${PATH}/get-by-product-code-location-group?productCode=${productCode}&locationGroupId=${locationGroup}`);
    }

    function getExceptionListsToPackByCommercialSegmentId(commercialSegmentIds: string[]): Promise<ExceptionListEntityResponse[]> {
        return GET(`${PATH}/unassociated-to-pack?commercialSegmentIds=${commercialSegmentIds}`);
    }


    return {
        getExceptionList,
        getExceptionListsByCommercialCategoryId,
        isExceptionListInUse,
        getExceptionLists,
        getRatePlanPaged,
        putExceptionList,
        postExceptionList,
        deleteExceptionList,
        getExceptionListsPaged,
        getRatePlan,
        terminateExceptionList,
        getExceptionPagedProductPlan,
        getExceptionListsToPackByCommercialSegmentId
    };
};